import React, { Component, PureComponent } from "react";
import { BEIN_SPL_OFFER, delayTime, STRIPE_PK } from "../../util/config/Constants";
import { connect } from "react-redux";
import {
  getConfig,
  markCodeRedeemed,
  updateInventory,
  updateVBPInner,
} from "../../actions/RandomizerAction";
import "./Offer.css";
import Footer from "../footer/Footer";
import {
  clearSession,
  getUrlWord,
  showEmbedFooter,
} from "../../util/helpers/Helpers";
import { OFFER_TYPE } from "../../util/config/app-config";
import { loadStripe } from "@stripe/stripe-js";
import {
  buildHeaders,
  generateUrlApiV2,
} from "../../util/helpers/MiddlewareHelpers";
import content_copy from './../../assets/images/content_copy.png';
import SpinWheel from "../../components/SpinWheel";

const TIMER_KEY = "content_display_timer_end";

export class OfferPay extends PureComponent {
  constructor(props) {
    super(props);
    this.redeem = this.redeem.bind(this);
    this.param =
      this.props &&
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.param
        ? this.props.match.params.param
        : "";
    this.state = {
      delayTime: delayTime,
      showBtn: false,
      hash: "",
      spinComplete: false,
      stripePromise: null,
      loading: true,
      error: null,
      data: null,
      remainingSeconds: 0,
      isCopied: false,
    };
  }

  componentDidMount(prevProps, prevState, snapshot) {
    // let hash = this.props.location.hash;
    // hash = hash ? hash.replace(/(^#)/g, "") : "";
    let hash = getUrlWord(this.props.match.url, this.props.location.hash);
    if (hash) {
      // const config = useSelector(state => {
      //   console.log('state-new', state);
      // });
      // console.log('dispatch-new', config);
      // this.props.dispatch(getConfig(hash, this.props.dispatch));
      this.setState({ hash });
    }
    this.fetchData(this.param);
    console.log("props-over", this.props);
  }

  copyTextToClipboard = async (textToCopy) => {

    try {
      await navigator.clipboard.writeText(textToCopy);
      // Update state on success
      this.setState({ isCopied: true });

      // Reset the "Copied!" message after 2 seconds
      setTimeout(() => {
        this.setState({ isCopied: false });
      }, 2000);

    } catch (err) {
      console.error('Failed to copy text: ', err);
      // Optional: Provide error feedback
      alert('Failed to copy text!');
    }
  }

  async fetchData(param) {
    this.setState({ loading: true, error: null });
    try {
      const headers = buildHeaders();
      const url = generateUrlApiV2(`/competition/getRandData`);

      const res = await fetch(url, {
        method: "POST",
        crossdomain: true,
        headers,
        body: JSON.stringify({ uuid: param }),
      });
      if (!res.ok) throw new Error(`API error ${res.status}`);
      const json = await res.json();

      // if (json && json.idCompetition) {
      // let orderPaid = localStorage.setItem(`${json.idCompetition}-orderPaid`, true);
      // if (json.orderStatus === 'pending' && orderPaid) {
      // }
      // }
      // Expecting shape: { logo, title, description, image, items: [{logo, text}, ...] }

      if (json.orderStatus === "paid" && this.props && this.props.config && this.props.config.id) {
        localStorage.setItem(`${this.props.config.id}-orderPaid`, true);
      }
      this.setState({ data: json, loading: false });
    } catch (err) {
      this.setState({ error: err.message || "Fetch error", loading: false });
    }
  }

  initializeStripe = () => {
    this.setState({
      stripePromise: loadStripe(
        STRIPE_PK,
      ),
    });
  };

  checkAndRouteUrl() {
    let hash = getUrlWord(this.props.match.url, this.props.location.hash);
    console.log("hashssss", hash);
    if (hash.includes("/")) {
      this.props.history.push(hash);
    } else if (hash.includes("__CURL_")) {
      this.props.history.push("");
    } else {
      // [hash removal] remove this after hash migration
      this.props.history.push("/#" + hash);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps && prevProps.config && prevProps.config.id) {
      let idComp = prevProps.config.id;
      const offer = JSON.parse(localStorage.getItem(`${idComp}-offer`));

      // if (!offer || !offer.offer) {
      //   this.clearSessionAndRevertToHome(idComp);
      // }
    }

    if (
      this.props !== prevProps &&
      prevProps &&
      prevProps.config &&
      prevProps.config.id
    ) {
      let idComp = prevProps.config.id;
      if (!this.state.stripePromise && [2673].includes(prevProps.config.id)) {
        console.log("stripe-new");
        this.initializeStripe();
      }
      const allowMultiUserEntry = localStorage.getItem(
        `${idComp}-allowMultiUserEntry`,
      );
      console.log("allowww", allowMultiUserEntry);
    }
  }

  redeem = (selectedOffer) => {
    const idComp = this.props.config.id;
    const idOptin = localStorage.getItem(`${idComp}-idOptin`);
    const offerData = JSON.parse(localStorage.getItem(`${idComp}-offer`));

    console.log("offerData-", offerData);
    console.log("idptin-", idOptin);
    console.log("comp-", this.props.config);

    if (
      this.props &&
      this.props.config &&
      this.props.config.randomizerConfigs &&
      this.props.config.randomizerConfigs.redemptionType == 2 &&
      idOptin &&
      offerData &&
      offerData.idVoteRandomizer
    ) {
      let payload = {
        id: selectedOffer.id,
        inventory: 10,
        idVoteRandomizer: offerData.idVoteRandomizer,
      };
      this.props.dispatch(
        markCodeRedeemed(idComp, payload, this.props.dispatch),
      );
      // }
    }
    console.log("offer-opened");
    window.open(selectedOffer.offerUrl, "_blank");
  };

  handleCallbackAfterSpin = (spinData) => {
    console.log("spin-Data", spinData);
    // Update the name in the component's state
    this.setState({ spinComplete: true });
  };

  triggerVBooster = (vBooster) => {
    console.log("vBooster-props", this.props);

    if (vBooster.ctaLink && vBooster.ctaLink != "") {
      window.open(vBooster.ctaLink, "_blank");
    }

    const idOptin = localStorage.getItem(`${vBooster.idCompetition}-idOptin`);
    if (vBooster.idCompetition && vBooster.id && idOptin) {
      var params = {
        idComp: vBooster.idCompetition,
        idCompVB: vBooster.id,
        idOptin,
      };

      this.props.dispatch(
        updateVBPInner(vBooster.idCompetition, params, this.props.dispatch),
      );
    }
  };

  clearSessionAndRevertToHome = (idComp) => {
    clearSession(idComp);

    const hasEmbedFooter = showEmbedFooter();

    let finalStateUrl = `/#${this.state.hash}`;

    if (this.state.hash.includes("/")) {
      if (hasEmbedFooter) {
        finalStateUrl = `${this.state.hash}?embed=true`;
      } else {
        finalStateUrl = this.state.hash;
      }
    } else if (this.state.hash.includes("__CURL_")) {
      if (hasEmbedFooter) {
        finalStateUrl = `?embed=true`;
      } else {
        finalStateUrl = "";
      }
    } else {
      // [hash removal] remove this after hash migration
      if (hasEmbedFooter) {
        finalStateUrl = `/?embed=true#${this.state.hash}`;
      }
    }
    this.props.history.push(finalStateUrl);
  };

  openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  render() {
    let { config } = this.props;
    console.log("opay", config);
    console.log("props-over", this.props);
    let voteConts = "";
    const { data } = this.state;

    const hasEmbedFooter = showEmbedFooter();

    if (config && Object.keys(config).length > 0 && data) {
      // let offerData = JSON.parse(localStorage.getItem(`${config.id}-offer`));
      let selectedOffer = data;
      console.log("offer-set", selectedOffer);

      let code = false;
      if (selectedOffer.codeType == 1) {
        code = selectedOffer.code;
      } else {
        code = selectedOffer.codeUnique;
      }

      let offerViewed = localStorage.getItem(`${config.id}-offerViewed`);
      let orderPaid = localStorage.getItem(`${config.id}-orderPaid`);

      // if (offerViewed && !isSessionActive(config.id)) {
      //   this.clearSessionAndRevertToHome(config.id);
      // }

      const selec = 0;
      const offerData = [];
      const spinData = [];

      voteConts = (
        <React.Fragment>
          {/* {config.logoBg ? (
            <div className={'logos-cont main-logo-cont'}>
              {!config.logoFullscreen ? (
                <img src={config.logoBg.file} alt={config.name} className={'logo-image'} />)
                : (<div ng-if="logoFullscreen" onClick={this.scrollToAfterLogo}
                  style={{background: `url(${config.logoBg.file}) no-repeat center center`, height: '100vh',
                      backgroundSize: 'cover', cursor: 'pointer'}}></div>)
              }
              <div id="postLogoSect" style={{ visibility: 'hidden' }}></div>
            </div>
          ) : null}*/}

          <br />

          <div
            className="offer-data-block"
            style={{ width: "100%", color: config.primaryColor }}
          >
            {selectedOffer &&
            selectedOffer.offerImageUrl &&
            selectedOffer.offerImageUrl != "" ? (
              <div className={"m-auto w-100"}>
                <img
                  src={selectedOffer.offerImageUrl}
                  className={"offer-won-image"}
                  alt="Offer"
                />
              </div>
            ) : null}

            {/* <h1 className="offer-text">{selectedOffer.description}</h1>*/}

            {selectedOffer.orderStatus === "paid" ? (
              <div className="overflow-auto thanks-offer">
                <div className="col-sm-12">
                  {BEIN_SPL_OFFER.includes(selectedOffer.id) ? <div className="thanks-lg title-font">Thanks for purchasing!</div> : ''}
                  <div className="thanks-lg">Your unique code is:</div>
                  <div className="thanks-offer-code">{selectedOffer.code} <img onClick={() => this.copyTextToClipboard(selectedOffer.code)} src={content_copy}/></div>
                  {this.state.isCopied ? <div>copied</div> : ''}
                  <p>To redeem your code, simply follow these instructions:</p>

                  <div
                    className={"primary submit-optin cursor_pointer green-btn"}
                    onClick={() => this.openInNewTab('https://cpnl.ink/782762s2')}
                    style={{
                      display: "block",
                    }}
                  >
                    READ INSTRUCTIONS
                  </div>
                  <p>
                    (We’ve also emailed the unique code and instructions to
                    you.)</p>
                  <p>Need more help? Email us at <a href="mailto:help@campaignware.com">help@campaignware.com</a>
                  </p>
                </div>
              </div>
            ) : null}

            {selectedOffer.orderStatus === "pending" && orderPaid ? (
              <div className="overflow-auto thanks-offer">
                <div className="col-sm-12">
                  {BEIN_SPL_OFFER.includes(selectedOffer.id) ? <div className="thanks-lg title-font">Thanks for purchasing beIN SPORTS CONNECT!</div> : ''}
                  <div className="thanks-lg">We've received your order, and you should get an email from us within the next 5 minutes containing your activation code.</div>
                  <p>Didn't get your code?
                  Email us at <a href="mailto:help@campaignware.com">help@campaignware.com</a> for assistance.
                  </p>
                </div>
              </div>
            ) : null}

            {offerViewed &&
            config.randomizerConfigs.isOfflineRedemption !== 1 &&
            config.randomizerConfigs.isRedemptionUrlEnabled === 1 &&
            selectedOffer.offerUrl &&
            selectedOffer.offerUrl != "" ? (
              <div className="m-auto w-100">
                <div
                  className={
                    "primary submit-optin cursor_pointer mb-5" +
                    (hasEmbedFooter ? "" : " no-embed")
                  }
                  onClick={() => this.redeem(selectedOffer)}
                  style={{
                    backgroundColor: config ? config.buttonColor : "",
                    color: config ? config.secondaryColor : "",
                    display: "block",
                  }}
                >
                  Redeem
                </div>
              </div>
            ) : null}

            {config.isViralSharingEnabled &&
            config.viralBoosters &&
            config.viralBoosters.length ? (
              <div className="w-100">
                <div className="col-sm-12">
                  <div className="v-booster-section">
                    {config.drawCopy && config.drawCopy != "" ? (
                      <div className="v-b-info">
                        <span
                          style={{
                            color: config.primaryColor
                              ? config.primaryColor
                              : "#FFFFFF",
                          }}
                          dangerouslySetInnerHTML={{ __html: config.drawCopy }}
                        ></span>
                      </div>
                    ) : (
                      ""
                    )}
                    {config.viralBoosters.map((vb, vbIndex) => (
                      <div
                        className="v-booster"
                        style={{
                          backgroundColor: vb.buttonColor
                            ? vb.buttonColor
                            : "#808080",
                          color: vb.textColor ? vb.textColor : "#FFFFFF",
                        }}
                        onClick={() => this.triggerVBooster(vb)}
                        key={vbIndex}
                      >
                        {vb.image ? <img src={vb.image.file} /> : ""}
                        <span className="v-b-text">{vb.ctaText}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : null}

          </div>

          <Footer />
        </React.Fragment>
      );
    }

    let noBorderRadius = config && config.defaultShape === 2;

    return (
      <div className={"offer " + (noBorderRadius ? "no-border-radius" : "")}>
        {voteConts}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  console.log("props-state", state);
  return {
    ...ownProps,
    config: state.default.data.config,
    locale: state.default.locale,
    offer: state.default.data.offer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferPay);
